import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { useValue } from '@morningtrain/react-resources'

function Length (props) {
  const value = useValue(props.name, props.defaultValue)

  if (!value || typeof value[Symbol.iterator] !== 'function') {
    return null
  }

  if (typeof value.length !== 'undefined') {
    return value.length
  }

  let count = 0

  for (const i of value) {
    count = count++
  }

  return count
}

Length.defaultProps = {
  defaultValue: null
}

Length.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.any
}

export default observer(Length)
